import type { SubTemplateProps } from '@/deskUiSkeletons/rowTemplates/RowTemplateTypes'

// Standard-surface-owned email compatibility row.

export function LegacyEmailTemplate({ controls, slots }: SubTemplateProps) {
  return (
    <>
      <div className="md-legacy-email-row flex min-h-6 clear-both items-center border-y border-b-[#2f75b5] border-t-white bg-[#d9d9d9] text-[#07c] text-[13px] leading-5 font-[Arial,Tahoma,Verdana,sans-serif]">
        <div className="md-legacy-email-icons flex min-w-[26px] flex-[0_0_auto] items-center pl-1">
          {controls.iconStrip}
        </div>
        <div className="md-legacy-email-text flex min-w-0 flex-1 items-center gap-2 [&>:first-child]:min-w-[120px] [&>:first-child]:flex-[0_1_auto] [&>:last-child]:min-w-[180px] [&>:last-child]:flex-1 [&_.md-sub-title-link]:text-[#07c] [&_.md-sub-title-subject]:text-[#07c]">
          {controls.header}
          {controls.text}
        </div>
        {controls.meta}
      </div>
      {slots.allChildren}
    </>
  )
}
